import React from 'react';
import { connect } from 'react-redux';
import DataTable from '../../DataTable/DataTable';
import { getPortfolioAction } from '@/actions/trading';
import { dataType } from '@/constants/data-type';
import classnames from 'classnames';
import { getSafe , getSafeStorage} from '@/helpers/global';
import { Comparator, utilsFunction,formatFunctions } from '@/helpers/functions';
import { PARAMS as requestParams } from '@/constants/params';
import { APP_LANGUAGE_SUPPORTS } from '@/constants/app';
import TabHeader from '../../TabHeader/TabHeader';
import { CUSTOM_STYLES } from '@/constants/app';
import { SERVICES_RESP } from '@/configurations';
import Dropdown from '@/components/Dropdown/Dropdown';
import { stockActions } from '@/actions/trading/stock.action';
import { LoggerFactory } from '@ag-grid-community/all-modules';
import { STORAGE_KEY as storageKey } from '@/constants/storage.key';

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: props.language.common_actions,
          colId: 'common_actions',
          field: 'action',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action no-focus',
          dataType: dataType.BUY_SELL,
          sortable: false,
          minWidth: 60
        },
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'stockCode',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          cellRendererParams: {
            market: 'marketID',
            instrument: 'stockCode'
          },
          minWidth: 80
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'stockChineseShortName',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.STOCK_NAME,
          tooltipField: utilsFunction.switchToolTipsLanguage(this.props.language, 'stockName', 'stockChineseShortName'),
          cellRendererParams: {
            stockName: 'stockShortName',
            chineseStockName: 'stockChineseShortName'
          }
        },
        {
          headerName: props.language.common_market,
          colId: 'common_market',
          field: 'marketID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          // minWidth: 60
        },
        // {
        //   headerName: props.language.common_price,
        //   colId: 'common_price',
        //   field: 'refPrice',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.CURRENCY,
        //   comparator: Comparator.numberComparator,
        //   minWidth: 60
        // },
        {
          headerName: props.language.common_quantity,
          colId: 'common_quantity',
          field: 'ledgerQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          // minWidth: 80
        },
        {
          headerName: props.language.account_portfolio_ledger_bal,
          colId: 'account_portfolio_ledger_bal',
          field: 'ledgerQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          // minWidth: 90
        },
        {
          headerName: props.language.account_portfolio_pending_buy,
          colId: 'account_portfolio_pending_buy',
          field: 'todayBuyNonExeQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          // minWidth: 100
        },
        {
          headerName: props.language.account_portfolio_outstanding_sell,
          colId: 'account_portfolio_outstanding_sell',
          field: 'todaySellNonExeQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          // minWidth: 120
        },
        {
          headerName: props.language.account_portfolio_pending,
          colId: 'account_portfolio_pending',
          field: 'pending',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          // minWidth: 120
        },
        {
          headerName: props.language.account_portfolio_hold,
          colId: 'account_portfolio_hold',
          field: 'tmanualHold',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          // minWidth: 60
        },
        // {
        //   headerName: props.language.account_portfolio_stock_option_hold,
        //   colId: 'account_portfolio_stock_option_hold',
        //   field: 'lockUpQty',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell cell-action',
        //   dataType: dataType.CURRENCY,
        //   comparator: Comparator.numberComparator,
        //   minWidth: 60
        // },
        {
          headerName: props.language.common_market_value,
          colId: 'common_market_value',
          field: 'marketValue',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          // minWidth: 100
        },
        // {
        //   headerName: props.language.common_average_cost,
        //   colId: 'common_average_cost',
        //   field: 'totalAverageCost',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell cell-action',
        //   dataType: dataType.AVG_PRICE,
        //   comparator: Comparator.numberComparator,
        //   minWidth: 100
        // },
        {
          headerName: props.language.common_tradable_quantity,
          colId: 'common_tradable_quantity',
          field: 'tradableQty',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          // minWidth: 80
        },
        // {
        //   headerName: props.language.common_floating_pl,
        //   colId: 'common_floating_pl',
        //   field: 'floatingPL',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell text-end',
        //   dataType: dataType.FLOATING_PL_PERCENT,
        //   bindingColor: true,
        //   cellRendererParams: {
        //     percent: 'floatingPLPercent',
        //     floating: 'floatingPL'
        //   },
        //   comparator: Comparator.numberComparator
        // },
        {
          headerName: props.language.common_currency,
          colId: 'common_currency',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TEXT,
          // minWidth: 80
        },
        {
          headerName: props.language.current_account_today_exe_buy,
          colId: 'current_account_today_exe_buy',
          field: 'ttodayConfirmBuy',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 60
        },
        {
          headerName: props.language.current_account_today_exe_sell,
          colId: 'current_account_today_exe_sell',
          field: 'ttodayConfirmSell',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 60
        }
      ],
      data: null,
      portfolio: [{
        id: '1', title: 'portfolio_title', isActive: false
      }],
      totalMarket: '',
      totalFloatingPL: '',
      totalFloatingPLPercent: '',
      marketCode: '',
      allMarkets: []
    }
    props.innerRef(this);
  }

  handleChangeMarket = (market) => {
    const marketCode = market ? market.value : null;
    if (marketCode || marketCode === '') {
      this.setState({
        marketCode
      }, () => {
        const { tradeConfigSettings, tradeDateInfoList } = this.props;
        // this.props.changeMarket(marketCode, tradeDateInfoList, tradeConfigSettings);
        this.getPortfolio()
      })
    }
  }

  getPortfolio = () => {
    const { user, currentTradingAccount, language } = this.props
    const { clientID } = currentTradingAccount
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      [requestParams.MARKET_ID]: this.state.marketCode,
    }
    this.portfolioRef.toggleLoadingOverlay(true);
    this.props.getAccountPortfolio(params, res => {
      if (res.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        if (res.portfoliosList) {
          this.setState({
            data: res.portfoliosList,
            totalMarket: res.totalMarket,
            totalFloatingPL: res.totalFloatingPL,
            totalFloatingPLPercent: res.totalFloatingPLPercent
          })
        } else {
          this.setState({ data: [] })
        }
      } else {
        this.setState({ data: [] })
      }
      this.portfolioRef.toggleLoadingOverlay(false);
    })
  }

  componentDidMount() {
    const { currentTradingAccount, markets,language} = this.props
    const token = getSafeStorage(storageKey.TOKEN)
    let allMarkets = JSON.parse(JSON.stringify(markets));
    allMarkets.push({
      label: "market_all",
      value: ""
    })
    if ( currentTradingAccount && token && allMarkets) {
      this.setState({
        allMarkets
      },() => {
        this.getPortfolio()
      })
    }
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount, isNeedRefresh, language, markets } = this.props
    if (currentTradingAccount && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getPortfolio()
    }
    if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
      this.getPortfolio()
    }
    if (language && preProps.language !== language) {
      this.getPortfolio()
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }


  render() {
    const { language, isMobile, markets, isFilter, autoSize, tabHeader, pageSize } = this.props;
    const { data, columnDefs, portfolio, totalFloatingPLPercent, totalFloatingPL, totalMarket, allMarkets} = this.state;
    return (
      <React.Fragment>
        <div className={classnames("section-table")}>
          {
            tabHeader && <TabHeader tabs={portfolio} refresh customStyle={CUSTOM_STYLES.HEADER_NORMAL} onRefresh={() => this.getPortfolio()}
              marketFilter={!isFilter} onChangeMarket={this.handleChangeMarket}
            />
          }
          {
            isFilter && allMarkets && <div className={classnames("section-action-panel")}>
              <span>{getSafe(() => language.common_market)}:</span>
              <div className={classnames("section-action-box", "border-style")}>
                <Dropdown selectedOptions={[allMarkets[allMarkets.length-1]]}
                  options={allMarkets}
                  innerRef={(e) => this.marketRef = e}
                  onChange={(mrk) => this.handleChangeMarket(mrk[0])}
                >
                </Dropdown>
              </div>
              <div className="section-action-box">
                <div>
                  {getSafe(() => language.portfolio_market_value)}:
                  <span className="margin-10">{totalMarket ? formatFunctions.dataFormat(totalMarket,dataType.CASH) : '-'}</span>
                </div>
                <div>
                  <span>{getSafe(() => language.portfolio_tips_one)}</span>{' '}
                  <span style={{ color: 'red' }}>{'*'}</span>
                  <span>{getSafe(() => language.portfolio_tips_two)}</span>
                </div>

              </div>
            </div>
          }
          <DataTable
            columnDefs={columnDefs}
            data={data}
            pageSize={pageSize}
            innerRef={e => this.portfolioRef = e}
            autoSizeColumns={autoSize}
          />
        </div>
      </React.Fragment>
    )
  }


  bindingColor(value) {
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }
}

Portfolio.defaultProps = {
  isFilter: false,
  autoSize: true,
  tabHeader: true,
  pageSize: 10,
  innerRef: () => { },
}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: state.trade.markets,
    isNeedRefresh: state.refresh.orderTable,
    token: state.auth.token,
    tradeConfigSettings: state.trade.tradeConfigSettings,
    tradeDateInfoList: state.trade.tradeDateInfoList
  }),
  dispatch => ({
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    changeMarket: (p, p2, res) => dispatch(stockActions.changeMarketAction(p, p2, res))
  })
)(Portfolio)
